import { IBooking, ICustomer } from 'shared-types/index';
import ObjectCopyService from 'external-services/object-copy-service/index';
import { AxiosInstance } from 'axios';
import AdminService from 'external-services/diary-admin-service/admin.service';

import CustomerUpdateService from 'external-services/customer-update-service/customerUpdate.service';
import DateUtilsService from 'external-services/date-utils-service';
import CustomerLookupService from 'external-services/customer-lookup-service';
import NetworkRequestsService from 'external-services/network-requests-service';

const NS = 'CustomerNotificationService'; // jshint ignore:line
const api: AxiosInstance = NetworkRequestsService.getGlobalAPI();
export const getApiInstanceForTests = (): AxiosInstance => api as AxiosInstance;
class CustomerNotificationService {

  /**
   * Send Email
   * @param {email} Email
   */
  public async sendLinkPayment(
    booking: IBooking,
    newEmail: string,
    saveToCustomer: boolean,
    url: string,
    bookedByNotification = false
  ): Promise<boolean> {
    if (!booking) {
      return Promise.resolve(false);
    }

    // Online request chuncked to not exceed browsers URI length limit
    // var requests = [];
    // var idsChunkSize = 40;
    //
    const info = ObjectCopyService.angularSafeCopy(booking);
    // @ts-ignore
    let customer: ICustomer = {};
    if (info.customerId) {
      customer = await CustomerLookupService.getById(info.customerId);
      info.customer = customer;
    }
    // Integrate customer and notification into the notification data
    //delete info.customerId;
    info.time = DateUtilsService.dateToDateTimeStr(info.time);
    return api
      .post(
        AdminService.getVenueEndpointURL() + '/sendLinkPayment',
        info,
        {
              params: {
                email: newEmail,
                url: url,
                bookedByNotification,
              },
            }
      )
      .then(() => {
        if (saveToCustomer && info.customerId) {
          customer.email = newEmail;
          CustomerUpdateService.update(customer);
        }
        return true;
      })
      .catch((error) => {
        console.log('------------------', error);
        return false;
      });
  }

  /**
   * Send sms payment link
   * @param {mobilePhone} mobilePhone
   */
  public async sendSmsLinkPayment(
    booking: IBooking,
    mobilePhone: string,
    saveToCustomer: boolean,
    url: string,
    bookedByNotification = false
  ): Promise<boolean> {
    if (!booking) {
      return Promise.resolve(false);
    }
    const info = ObjectCopyService.angularSafeCopy(booking);

    // @ts-ignore
    let customer: ICustomer = {};
    if (info.customerId) {
      customer = await CustomerLookupService.getById(info.customerId);
      info.customer = customer;
    }
    info.time = DateUtilsService.dateToDateTimeStr(info.time);
    return api
      .post(
        AdminService.getVenueEndpointURL() + '/sendSmsLinkPayment',
        info, {
              params: {
                mobilePhone: mobilePhone,
                url: url,
                bookedByNotification,
              },
            }

      )
      .then(() => {
        if (saveToCustomer && info.customerId) {
          customer.phone = mobilePhone;
          CustomerUpdateService.update(customer);
        }
        return true;
      })
      .catch(() => {
        return false;
      });
  }
}

const instance = new CustomerNotificationService();
export default instance as CustomerNotificationService;
